import contactForm from '@/api/contact_forms'

export default ({ commit }) => {
  return new Promise((resolve, reject) => {
    contactForm.getContactForm(result => {
      commit('setContactForm', result.data.data)
      resolve(result.data.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/actions/getContactForm.js